import { FeatureKey } from 'common/constants/permission'
import { WaterTableFilter } from 'modules/water/api/types'
import { atom } from 'recoil'

export const waterDateFilterState = atom<Date>({
  key: 'waterDateFilterState',
  default: new Date(),
})

export const waterDateTableFilterState = atom<Date | undefined>({
  key: 'waterDateTableFilterState',
  default: undefined,
})

export const selectedWaterIdState = atom<number | undefined>({
  key: 'selectedWaterIdState',
  default: undefined,
})

export const waterTableFilterState = atom<WaterTableFilter>({
  key: 'waterTableFilterState',
  default: FeatureKey.WaterQuality,
})

export const selectedWaterQualityDateState = atom<string>({
  key: 'seletedWaterQualityDateState',
  default: '',
})
